import { formatDate } from '../../utils';

const transformPathways = (data) => {
  const { results, conditions, timings, actions, triggers } = data;
  if (results) {
    return results.map(({ createdAt, ...item }) => ({
      ...item,
      createdOn: formatDate(createdAt),
    }));
  }
  return conditions && timings && actions && triggers
    ? { conditions, timings, actions, triggers }
    : null;
};

export default transformPathways;
